import { render } from "./Informations.vue?vue&type=template&id=0b50bec1&scoped=true"
import script from "./Informations.vue?vue&type=script&lang=js"
export * from "./Informations.vue?vue&type=script&lang=js"

import "./Informations.vue?vue&type=style&index=0&id=0b50bec1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b50bec1"]])

export default __exports__